import {log,_,moment} from '../globals';

class ViewAuthorizationFactory {
	
	$state:any;
	cookies:any;
	check:any = {
		user: () => {
			try {
				var tokenParts = this.cookies.user.token.split('|');
				var expiryDate;
				if(tokenParts.length == 3 || (tokenParts.length == 4 && (_.isEqual(tokenParts[3],'false') || _.isEqual(tokenParts[3],'true')))){
					//console.log("######### User was using old token format  in view auth #########");
					
					expiryDate = tokenParts[2];	

					if (tokenParts.length > 3 && tokenParts[3] !== 'false') {
						return false;
					}
				}else{
					expiryDate = tokenParts[3];
					//console.log("######### User was using new token format in view auth  #########");
					if (tokenParts.length > 4 && tokenParts[4] !== 'false') {
						return false;
					}
				}
				if (Number(expiryDate) > +moment()) {
					var tokenParts = this.cookies.user.token.split('|');

					return true;
				} else {
					delete this.cookies.user.token;
					this.cookies.save();
				}
			}

			catch (e) {
				// inconsequential
			}

			return false;
		}
	};
	checkUser:Function = this.check.user;
	msg:any;
	views:any;
	
	static $inject = ['$state','CookieFactory','mySynchViewService'];
	constructor($state, cookies,mySynchViewService) {
		 this.$state = $state;
		 this.cookies = cookies;
		 this.views = mySynchViewService.getViews();
	}
	

	private checkPermission(identity, permission) {
		return _.has(((identity || {}).permissions || {}), permission.name || permission);
	}

	private checkRole(identity, role) {
		return _.has(((identity || {}).roles || {}), role.name || role);
	}

	private checkPersonType(identity, personType) {
		return _.isEqual(((identity || {}).PersonTypeId || {}), personType.value || personType);
	}

	private missingPermissions(identity, permissions) {
		return _.map(_.reject(permissions, (permission) => {
			return this.checkPermission(identity, permission);
		}), (i) => {
			var permissionName = _.get(i,'name',"");
			return _.isNull(permissionName) || _.isEmpty(permissionName) ? i : permissionName;
		});
	}

	private missingRoles(identity, roles) {
		return _.map(_.reject(roles, (role) => {
			var roleName = _.get(role,'name',"");
			return this.checkRole(identity, roleName);
		}), (i) => {
			var roleName = _.get(i,'name',"");
			return _.isNull(roleName) || _.isEmpty(roleName) ? i : roleName;
		});
	}
	private missingPersonTypes(identity, personTypes) {
		return _.map(_.reject(personTypes, (personType) => {
			return this.checkRole(identity, personType);
		}), (i) => {
			var personTypeName = _.get(i,'name',"");
			return _.isNull(personTypeName) || _.isEmpty(personTypeName) ? i : personTypeName;
		});
	}
		

		getAuthorizedPage(page) {
			if (!_.includes(['Login', 'Welcome', 'WelcomeToFarm', 'ForgotPassword', 'PasswordReset'], page)) {
				if (!this.check.user()) {
					return 'Login';
				}
			}
			//TODO: update this logic if we add or include other restrictions with other HMS types
			 var hasHMSLandingPagePermission = false;
			 var invalidHMSLandingPage = 'User';
			 var herds = _.get(this.cookies,'state.activeFarm.herds');

			 if(!_.isUndefined(herds)){
				 var activeHerd = herds[0];

				 if(_.includes(["DC305"], _.get(activeHerd,'herdMgmtSoftware'))){
					 hasHMSLandingPagePermission = true;
				 }
			 }
			 

			var restriction = {types: []};

			// require logins
			if (!_.isEmpty(restriction.types)) {
				if (!_.any(restriction.types, (authorizationType) => {
					return this.check[authorizationType]();
				})) {
					if(hasHMSLandingPagePermission === false){ return invalidHMSLandingPage; }
					else{ return 'User';}
				}
			}

			// require permissions
			if (this.views[page] && this.views[page].permissionRestriction) {
				var permissionRestriction = this.views[page].permissionRestriction;

				var permissions = _.get(permissionRestriction,'permissions',[]);
				if(!_.isEmpty(permissions)){
					if (!this.hasPermission(permissionRestriction.permissions, permissionRestriction.requiresAll)) {
						return permissionRestriction.redirect;
					}
				}
			}

			// require roles
			if (this.views[page] && this.views[page].roleRestriction) {
				var roleRestriction = this.views[page].roleRestriction;

				 var roles = _.get(roleRestriction,'roles',[]);
				 if(!_.isEmpty(roles)){

					var requiresAll = _.get(roleRestriction,'requiresAll',false);

					if(requiresAll){
					
						var roleEnums = _.pluck(roleRestriction.roles,'roleEnum');
						var rolesWithPersonTypeRestrictions = _.filter(roleRestriction.roles,(role) => { return !_.isUndefined(_.get(role,'personTypeRestrictions'));});
						
						var hasAllRoles = this.hasRole(roleEnums, requiresAll);
						var hasAllPersonTypeRestrictions = true;
						_.forEach(rolesWithPersonTypeRestrictions,function(role:any){
							
						var missingPersonType =  _.find(role.personTypeRestrictions,(personType)=>{ return !this.hasPersonType(personType);});
							
						if(!_.isUndefined(missingPersonType)){
							hasAllPersonTypeRestrictions = false;
							return false;
						}
							
						});

						if(!(hasAllRoles && hasAllPersonTypeRestrictions)){
							return roleRestriction.redirect;	
						}
							

					}else{

						var validRole =  _.find(roleRestriction.roles,(role:any)=>{ 
							return this.hasRole(role.roleEnum) && this.hasPersonType(_.get(role,'personTypeRestrictions',[]));
						});

						if(_.isUndefined(validRole)){
							return roleRestriction.redirect;
						}

						

					}
				}

				

			}
		
			// require person types
			if (this.views[page] && this.views[page].personTypeRestriction) {
				var personTypeRestriction = this.views[page].personTypeRestriction;

				var personTypes = _.get(personTypeRestriction,'personTypes',[]);
				if(!_.isEmpty(personTypes)){	
					if (!this.hasPersonType(personTypeRestriction.personTypes)) {
						// if(hasHMSLandingPagePermission === false && _.isEqual(personTypeRestriction.redirect,'KpiDashboard')){ return invalidHMSLandingPage; }
						// 	else{ return personTypeRestriction.redirect;}
						return personTypeRestriction.redirect;
					}
				}
			}

			// require betas
			if (this.views[page] && this.views[page].requiresFarmInBeta) {
				var requiresFarmInBeta = this.views[page].requiresFarmInBeta;

				var betas = _.get(requiresFarmInBeta,'betas',[]);
				if(!_.isEmpty(betas)){	
					if (!this.farmIsInBeta(betas)) {
						 return requiresFarmInBeta.redirect;	
					}
				}
			}

			 // if the page returned is KpiDashboard and the farm/herd doesn't have DC305 , then KpiDashboard isn't available and we need to redirect to User Profile
			if(_.isEqual(page,'KpiDashboard') && hasHMSLandingPagePermission === false){
				return invalidHMSLandingPage;
			}

			// passed checks
			return page;
		};

		
		 
		hasPersonType(identity, personTypes:any = undefined){
			if (typeof personTypes === 'undefined') {
				personTypes = identity;
				identity = this.cookies.user;
			}

			if (!_.isArray(personTypes)) {
				personTypes = [personTypes];
			}
				  // we need to first check that person has a valid person type , but if not we need to check if there are exceptions to the person type restriction
			if (!_.isEmpty(personTypes) && !_.any(personTypes, (personType) => {
					return this.checkPersonType(identity, personType);
				 })
			   ) {
					this.msg = 'user missing a person type from the acceptable list: ' + this.missingPersonTypes(identity, personTypes).join(', ');
					return false;
				}

		

			return true;
		};

		hasPermission(identity, permissions:any = undefined, requiresAll:any = undefined) {
			if (typeof requiresAll === 'undefined' && arguments.length === 2 && _.isBoolean(permissions)) {
				requiresAll = permissions;
				permissions = identity;
				identity = this.cookies.user;
			}

			if (typeof permissions === 'undefined') {
				permissions = identity;
				identity = this.cookies.user;
			}

			if (!_.isArray(permissions)) {
				permissions = [permissions];
			}

			if (requiresAll) {
				if (!_.all(permissions, (permission) => {
						return this.checkPermission(identity, permission);
					})
				) {
					this.msg = 'user missing required permissions: ' + this.missingPermissions(identity, permissions).join(', ');
					return false;
				}

				return true;
			}

			if (!_.isEmpty(permissions) && !_.any(permissions, (permission) => {
					return this.checkPermission(identity, permission);
				})
			) {
				this.msg = 'user missing a permission from the acceptable list: ' + this.missingPermissions(identity, permissions).join(', ');
				return false;
			}

			return true;
		};

		hasRole(identity, roles:any = undefined, requiresAll:any = undefined) {
			if (typeof requiresAll === 'undefined' && arguments.length === 2 && _.isBoolean(roles)) {
				requiresAll = roles;
				roles = identity;
				identity = this.cookies.user;
			}

			if (typeof roles === 'undefined') {
				roles = identity;
				identity = this.cookies.user;
			}

			if (!_.isArray(roles)) {
				roles = [roles];
			}
			// if requiresAll is true then the user needs to have all valid roles and if there are person type rescrtions 
			if (requiresAll) {
				if (!_.all(roles, (role) => {
						return this.checkRole(identity, role);
					})
				) {
					this.msg = 'user missing required roles: ' + this.missingRoles(identity, roles).join(', ');
					log.warn(this.msg);

					return false;
				}

				log.trace('user meets all required roles');

				return true;
			}

			if (!_.isEmpty(roles) && !_.any(roles,(role) => {
					return this.checkRole(identity, role);
				})
			) {
				this.msg = 'user missing a role from the acceptable list: ' + this.missingRoles(identity, roles).join(', ');
				return false;
			}

			return true;
		};
		 // allowedSoftware - array of software codes as strings
		hasHerdSoftwarePermission(allowedSoftware){
			// if no herd management software list was given , then all software types are allowed.
			if(_.isUndefined(allowedSoftware)){
				return true;
			}else{
				
				var herds = _.get(this.cookies.state,'activeFarm.herds',[]);

				var activeHerd = {};

				if(!_.isUndefined(herds) && herds.length > 0){
					  // TODO: update to account for multiple herds of business rules change 
					 // currently we only have one herd per farm so we only grab the first index of herds
					 activeHerd = herds[0]; 

					 var herdManagementSoftware = _.get(activeHerd,'herdMgmtSoftware');

					 return _.includes(allowedSoftware,herdManagementSoftware);

				}else{
					 // if the cookies doesn't have a herd for the active farm we assume false and the cookies should be fixed if needed.      
					return false;
				}
				
				
			}
			
			
		};

		 farmIsInBeta(requiredBetas){
			
			if(_.isUndefined(requiredBetas) || _.isEmpty(requiredBetas)){
				return true;
			}else{
				
				var allowedBetas = [];
				
				try{
					allowedBetas = JSON.parse(_.get(this.cookies.state,'activeFarm.allowedBetasJson',"[]"));

				}catch(e){
					console.log("failed to parse AllowedBetas for A farm in: view auth factory - farmIsInBeta");
				}
				
				var farmIsInARequiredBeta  = _.any(allowedBetas,(beta)=>{
												 return _.includes(beta,requiredBetas);
											 });
				 return _.isUndefined(farmIsInARequiredBeta) ? false : farmIsInARequiredBeta;				
			}
		};

	
	
}

angular.module('mySynch').service('ViewAuthorizationFactory', ViewAuthorizationFactory );

